import moment from "moment-timezone";
import * as changeCase from "change-case";

import Loading from "../../Infrastructure/Loading";
import { Col, Row } from "react-bootstrap";
import { useLookupViolationsQuery } from "../../../Redux/Services/lookupApi";

export default function Violations({
  boro,
  block,
  lot,
}: {
  boro: string;
  block: string;
  lot: string;
}) {
  const { data, isLoading } = useLookupViolationsQuery({
    boro,
    block,
    lot,
  });
  if (isLoading) return <Loading />;
  if (!data) return <div>data is undefined</div>;

  const violations = data.data;

  let hasResults = false;
  if (
    violations.violationsDob.data.length > 0 ||
    violations.violationsDobEcb.data.length > 0 ||
    violations.violationsHpd.data.length > 0
  ) {
    hasResults = true;
  }
  return (
    <div className="violations">
      <p>
        Violations issued in NYC Department of Housing, Preservation, and
        Development (HPD), Department of Buildings (DoB) and Environmental
        Control Board (DoB-ECB).
      </p>
      {!hasResults && <div>No active violations were found</div>}
      {violations.violationsDob.data.length > 0 && (
        <div>
          <h3>DOB Violations</h3>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Category</th>
                <th>ID</th>
                <th>Type</th>
                {/**
                <th>Violation Type Code</th>
                 */}
              </tr>
            </thead>
            <tbody>
              {violations.violationsDob.data.map((violation, index) => (
                <tr key={index}>
                  <td>
                    {moment(violation.issue_date, "YYYYMMDD").format(
                      "YYYY-MM-DD",
                    )}
                  </td>
                  <td>{violation.violation_category}</td>
                  <td>{violation.number}</td>
                  <td>{violation.violation_type}</td>
                  {/**
                  <td>{violation.violation_type_code}</td>
                   */}
                  <td className="mobile-only">
                    <Row>
                      <Col xs={6}>
                        <dt>Date</dt>
                        <dd>
                          {moment(violation.issue_date, "YYYYMMDD").format(
                            "YYYY-MM-DD",
                          )}
                        </dd>
                      </Col>
                      <Col xs={6}>
                        <dt>Category</dt>
                        <dd>{violation.violation_category}</dd>
                      </Col>
                      <Col xs={6}>
                        <dt>Type</dt>
                        <dd>{violation.violation_type}</dd>
                      </Col>
                      <Col xs={6}>
                        <dt>ID</dt>
                        <dd>{violation.number}</dd>
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {violations.violationsDobEcb.data.length > 0 && (
        <div>
          <h3>DOB ECB Violations</h3>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>ID</th>
                <th>Type</th>
                <th>Penality</th>
                <th>Paid</th>
                <th>Due</th>
              </tr>
            </thead>
            <tbody>
              {violations.violationsDobEcb.data.map((violation, index) => (
                <tr key={index}>
                  <td>
                    {moment(violation.issue_date, "YYYYMMDD").format(
                      "YYYY-MM-DD",
                    )}
                  </td>
                  <td>
                    {changeCase.capitalCase(
                      violation.ecb_violation_status || "",
                    )}
                    {" - "}
                    {changeCase.capitalCase(violation.hearing_status || "")}
                    <br />
                    {changeCase.capitalCase(
                      violation.certification_status || "",
                    )}
                  </td>
                  <td>
                    {violation.ecb_violation_number}
                    {violation.dob_violation_number && <br />}
                    {violation.dob_violation_number}
                  </td>
                  <td>
                    {violation.severity}
                    <br />
                    {violation.violation_type}
                  </td>
                  <td>{violation.penality_imposed}</td>
                  <td>{violation.amount_paid}</td>
                  <td>{violation.balance_due}</td>
                  <td className="mobile-only">
                    <Row>
                      <Col xs={6}>
                        <dt>Date</dt>
                        <dd>
                          {moment(violation.issue_date, "YYYYMMDD").format(
                            "YYYY-MM-DD",
                          )}
                        </dd>
                      </Col>
                      <Col xs={6}>
                        <dt>ID</dt>
                        <dd>
                          {violation.ecb_violation_number}
                          {violation.dob_violation_number && <br />}
                          {violation.dob_violation_number}{" "}
                        </dd>
                      </Col>
                      <Col xs={6}>
                        <dt>Status</dt>
                        <dd>
                          {changeCase.capitalCase(
                            violation.ecb_violation_status || "",
                          )}
                          {" - "}
                          {changeCase.capitalCase(
                            violation.hearing_status || "",
                          )}
                          <br />
                          {changeCase.capitalCase(
                            violation.certification_status || "",
                          )}
                        </dd>
                        <dt>Type</dt>
                        <dd>
                          {violation.severity}
                          <br />
                          {violation.violation_type}
                        </dd>
                      </Col>
                      <Col xs={6}>
                        <dt>Penality</dt>
                        <dd>{violation.penality_imposed}</dd>
                        <dt>Paid</dt>
                        <dd>{violation.amount_paid}</dd>
                        <dt>Due</dt>
                        <dd>{violation.balance_due}</dd>
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {violations.violationsHpd.data.length > 0 && (
        <div>
          <h3>HPD violations</h3>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                {/**
                <th>Issued Date</th>
                <th>Order Number</th>
                <th>Order ID</th>
                */}
                <th>Status</th>
                <th>ID</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {violations.violationsHpd.data.map((violation, index) => (
                <tr key={index}>
                  <td>
                    {moment(violation.currentstatusdate).format("YYYY-MM-DD")}
                  </td>
                  {/**
                  <td>
                    {moment(violation.novissueddate).format("YYYY-MM-DD")}
                  </td>
                  <td>{violation.ordernumber}</td>
                  <td>{violation.novid}</td>
                   */}
                  <td>
                    {violation.violationstatus}
                    {` (${changeCase.capitalCase(violation.currentstatus)})`}
                  </td>
                  <td>{violation.violationid}</td>
                  <td className="smaller">
                    <b>{`Class ${violation.class} Violation`}</b>
                    {(violation.apartment || violation.story) && (
                      <>
                        {" ("}
                        {violation.apartment && `APT: ${violation.apartment} `}
                        {violation.story && `Floor: ${violation.story}`}
                        {")"}
                      </>
                    )}
                    <br />
                    {violation.novdescription}
                  </td>
                  <td className="mobile-only">
                    <Row>
                      <Col xs={4}>
                        <dt>Date</dt>
                        <dd>
                          {moment(violation.currentstatusdate).format(
                            "YYYY-MM-DD",
                          )}
                        </dd>
                      </Col>
                      <Col xs={4}>
                        <dt>Status</dt>
                        <dd>
                          {violation.violationstatus}
                          {`: (${changeCase.capitalCase(violation.currentstatus)})`}{" "}
                        </dd>
                      </Col>
                      <Col xs={4}>
                        <dt>ID</dt>
                        <dd>{violation.violationid}</dd>
                      </Col>
                      <Col xs={12}>
                        <dt>Description</dt>
                        <dd>
                          <b>{`Class ${violation.class} Violation`}</b>
                          {(violation.apartment || violation.story) && (
                            <>
                              {" ("}
                              {violation.apartment &&
                                `APT: ${violation.apartment} `}
                              {violation.story && `Floor: ${violation.story}`}
                              {")"}
                            </>
                          )}
                          <br />
                          {violation.novdescription}
                        </dd>
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
